import { defineStore } from 'pinia';
// eslint-disable-next-line import/prefer-default-export
export const useAccountStore = defineStore('accountStore', {
  state: () => ({
    data: {},
    firebase: null,
    isLoading: false,
    sessionId: null,
    jwt: null,
  }),
  actions: {
  },
  getters: {
    Data: (state) => state.data,
    Distributor() {
      return this.data?.distributor || null;
    },
    Customer() {
      return this.data?.customer || null;
    },
    CustomerNames() {
      return this.Customer?.name || null;
    },
    CustomerId() {
      return this.Customer?.id || null;
    },
    Currency() {
      return this.Distributor?.currency || null;
    },
    DistributorId() {
      return this.Distributor?.id || null;
    },
    DistributorName() {
      return this.Distributor?.name || null;
    },
    DeliveryMethods() {
      return this.Customer?.deliveryMethods || [];
    },
    PaymentMethods() {
      return this.Customer?.paymentMethods || [];
    },
    WhatsAppNo() {
      return this.Distributor?.whatsAppNo || null;
    },
    OpenWhatsAppUrl() {
      if (!this.WhatsAppNo) {
        return 'https://wa.me';
      }
      return `https://wa.me/${this.WhatsAppNo}`;
    },
    Jwt: (state) => state.jwt,
    SessionId: (state) => state.sessionId,
  },
});
